var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.033,
    height: 19.357,
    viewBox: "0 0 21.033 19.357",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M-7.928,2.353H8.024a2.548,2.548,0,0,0,1.343-.344,2.374,2.374,0,0,0,.881-.924A2.659,2.659,0,0,0,10.56-.193a2.543,2.543,0,0,0-.081-.628,2.468,2.468,0,0,0-.252-.618L2.234-15.705a2.4,2.4,0,0,0-.945-.972A2.532,2.532,0,0,0,.043-17a2.553,2.553,0,0,0-1.235.328,2.382,2.382,0,0,0-.956.972L-10.13-1.439a2.56,2.56,0,0,0-.344,1.246,2.659,2.659,0,0,0,.312,1.278,2.374,2.374,0,0,0,.881.924A2.569,2.569,0,0,0-7.928,2.353Zm7.981-6.9a.8.8,0,0,1-.9-.892l-.14-5.285a.893.893,0,0,1,.269-.714,1.042,1.042,0,0,1,.763-.285,1.028,1.028,0,0,1,.752.285.973.973,0,0,1,.29.725L.935-5.436A.8.8,0,0,1,.054-4.544Zm0,3.47A1.207,1.207,0,0,1-.795-1.4a1.048,1.048,0,0,1-.354-.8,1.06,1.06,0,0,1,.354-.811,1.207,1.207,0,0,1,.849-.328A1.207,1.207,0,0,1,.9-3.013a1.06,1.06,0,0,1,.354.811A1.037,1.037,0,0,1,.9-1.4,1.224,1.224,0,0,1,.054-1.074Z",
    transform: "translate(10.474 17.005)",
    fill: "#333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReport);
export default __webpack_public_path__ + "static/media/report.09b2639ae2f3ee71f2844448b8f6d420.svg";
export { ForwardRef as ReactComponent };